package example.shadcn_kotlin.ui.pages.docs.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.pages.components.demo.PopoverDemo

@Page
@Composable
fun PopoverPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/components/popover.md", mapOf("title" to listOf("Popover"), "description" to listOf("Displays rich content in a portal, triggered by a button."), "component" to listOf("true"), "radix" to listOf()))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            ComponentPreview("""import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h4
import react.dom.html.ReactHTML.p
import shadcn.ui.components.*
import web.cssom.ClassName

val PopoverDemo = FC<Props> {
    Popover {
        PopoverTrigger {
            asChild = true
            Button {
                variant = "outline"
                + "Open popover"
            }
        }
        PopoverContent {
            className = ClassName("w-80")
            div {
                className = ClassName("grid gap-4")
                div {
                    className = ClassName("space-y-2")
                    h4 {
                        className = ClassName("font-medium leading-none")
                        +"Dimensions"
                    }
                    p {
                        className = ClassName("text-sm text-muted-foreground")
                        +"Set the dimensions for the layer ."
                    }
                }
                div {
                    className = ClassName("grid gap-2")
                    div {
                        className = ClassName("grid grid-cols-3 items-center gap-4")
                        Label {
                            htmlFor = "width"
                            +"Width"
                        }
                        Input {
                            id = "width"
                            defaultValue = "100%"
                            className = ClassName("col-span-2 h-8")
                        }
                    }
                    div {
                        className = ClassName("grid grid-cols-3 items-center gap-4")
                        Label {
                            htmlFor = "maxWidth"
                            +"Max.width"
                        }
                        Input {
                            id = "maxWidth"
                            defaultValue = "300px"
                            className = ClassName("col-span-2 h-8")
                        }
                    }
                    div {
                        className = ClassName("grid grid-cols-3 items-center gap-4")
                        Label {
                            htmlFor = "height"
                            +"Height"
                        }
                        Input {
                            id = "height"
                            defaultValue = "25px"
                            className = ClassName("col-span-2 h-8")
                        }
                    }
                    div {
                        className = ClassName("grid grid-cols-3 items-center gap-4")
                        Label {
                            htmlFor = "maxHeight"
                            +"Max. height"
                        }
                        Input {
                            id = "maxHeight"
                            defaultValue = "none"
                            className = ClassName("col-span-2 h-8")
                        }
                    }
                }
            }
        }
    }
}"""){ 
 PopoverDemo {} 
 }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("usage")
 }) {
                org.jetbrains.compose.web.dom.Text("Usage")
            }
            CodeBlock("""import shadcn.ui.components.Popover
import shadcn.ui.components.PopoverContent
import shadcn.ui.components.PopoverTrigger
""", lang= "kotlin", highlight= "")
            CodeBlock("""Popover {
    PopoverTrigger { +"Open" }
    PopoverContent { +"Place content for the popover here." }
}
""", lang= "kotlin", highlight= "")
        }
    }
}
